import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { chataiConversationsIsLoadingState, chataiDrawerOpenState } from '~/states/atoms/ChatAI'
import { chataiConversationsState } from '~/states/selectors/ChatAI'

import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined'
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import { Link, useMediaQuery } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { ChataiConversationDrawerActions } from './ChataiConversationDrawerActions'
import { ChataiConversationListItem } from './ChataiConversationListItem'

const MENU_ITEMS = [
  { path: '/', name: 'ダッシュボード', icon: <SpaceDashboardOutlinedIcon /> },
  { path: '/media-daily-data', name: '日次レポート', icon: <TodayOutlinedIcon /> },
  { path: '/media-weekly-data', name: '週次レポート', icon: <DateRangeOutlinedIcon /> },
  { path: '/affiliate-reward', name: 'アフィリエイト管理', icon: <PaidOutlinedIcon /> },
  { path: '/media-condition-group', name: '媒体グループ管理', icon: <LayersOutlinedIcon /> },
  { path: '/group-condition-category', name: 'グループカテゴリ管理', icon: <CategoryOutlinedIcon /> },
  { path: '/b4a-kpi-settings', name: 'KPI・固定費設定', icon: <TuneOutlinedIcon /> },
  { path: '/measures', name: '施策管理', icon: <CampaignOutlinedIcon /> },
  { path: '/form-analytics', name: 'フォーム分析', icon: <InsightsOutlinedIcon /> },
]

const isMenuActive = (pathname: string, path: string) =>
  path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`)

// import { useChataiConversations } from './useChataiConversations'

export function ChataiConversationDrawer() {
  // useChataiTitleGenerator()
  const theme = useTheme()
  const open = useRecoilValue(chataiDrawerOpenState)
  // const { fetchNextPage, hasNextPage } = useChataiConversations()
  const conversations = useRecoilValue(chataiConversationsState)
  const isLoading = useRecoilValue(chataiConversationsIsLoadingState)

  const loading = isLoading && conversations.length === 0

  const { pathname } = useLocation()
  const isSizeLg = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Drawer
      sx={{
        '.MuiPaper-root': {
          top: 0,
          width: 230,
          // #root の zoom: 0.9 を打ち消す
          height: 'calc(100vh / 0.9)',
          minHeight: 200,
          mt: 6,
        },
      }}
      slotProps={{
        paper: {
          sx: {
            justifyContent: 'space-between',
          },
        },
      }}
      anchor="left"
      // variant="permanent"
      variant="persistent"
      // variant="temporary"
      className="no-scrollbar"
      open={open && isSizeLg}
      hideBackdrop>
      <Stack>
        {/* メニューアクション */}
        <ChataiConversationDrawerActions />

        {/* 初期ローディング */}
        {/* {loading && <LinearProgress color="inherit" />} */}

        {/* 会話リスト */}
        {/* <InfiniteScroll
          loadMore={() => {
            void fetchNextPage()
          }}
          hasMore={hasNextPage}
          useWindow={false}> */}
        <Stack>
          {MENU_ITEMS.map(({ path, name, icon }) => {
            const active = isMenuActive(pathname, path)
            return (
              <ChataiConversationListItem key={path} active={active}>
                <Link
                  href={`${path}`}
                  variant="body2"
                  underline="none"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.25,
                    width: '100%',
                    px: 2,
                    py: 1.25,
                    boxSizing: 'border-box',
                    color: `${
                      active ? '#20a3af' : theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.standard.main
                    } !important`,
                  }}>
                  {icon}
                  {name}
                </Link>
              </ChataiConversationListItem>
            )
          })}
        </Stack>
        {/* </InfiniteScroll> */}
      </Stack>
      {/* 下部に張り付くボタン */}
      {/* <List
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: theme.palette.standard.light,
        }}>
        <Divider sx={{ mx: 1 }} />
        <ChataiDeleteConversationsButton />
      </List> */}
    </Drawer>
  )
}
